module.exports = __webpack_public_path__ + "static/media/man_thinking.3d6ffadc.png";